import { readUser } from '@directus/sdk';
import { useQuery } from '@tanstack/react-query';

import { ADMIN_SELECTED_USER_ID_KEY } from '#constants/localstorage-keys.ts';

import { directusClient } from '../../services/directusClient/directusClient.ts';
import { readMeWithAdminAccess } from './readMeWithAdminAccess.ts';

export const readCurrentUser = async () => {
  const me = await readMeWithAdminAccess();
  const role = me.role as { id?: string; admin_access?: boolean } | null;
  if (role?.admin_access === true) {
    const selectedUser = localStorage.getItem(ADMIN_SELECTED_USER_ID_KEY);
    if (selectedUser) {
      try {
        return await directusClient.request(readUser(selectedUser));
      } catch {
        // Selected user no longer valid — clear selection and fall back
        localStorage.removeItem(ADMIN_SELECTED_USER_ID_KEY);
        return me;
      }
    }
    return me;
  }
  return me;
};

export const useUserQuery = () =>
  useQuery({
    queryKey: ['user'],
    queryFn: async () => await readCurrentUser(),
    retry: 0,
  });
